import { css } from 'styled-components';
import token from 'styled-token';
import { StyledIcon } from '../../components/Icon/Icon.styles';
import { spaceMixin } from '../spaceMixin';

/** @class RatingStars */
/** @method */
export var RatingStarsMixin = function RatingStarsMixin(props) {
  var value = props.value;
  return token({
    fontSize: 'RatingStars.fontSize',
    valueColor: 'RatingStars.valueColor',
    noValueColor: 'RatingStars.noValueColor',
    marginRight: 'RatingStars.marginRight'
  }, function (_ref) {
    var fontSize = _ref.fontSize,
      valueColor = _ref.valueColor,
      noValueColor = _ref.noValueColor,
      marginRight = _ref.marginRight;
    return css(["display:inline-flex;font-size:", "px;", "{color:", ";&:not(:last-child){margin-right:", ";}}"], fontSize, StyledIcon, value === null ? noValueColor : valueColor, marginRight ? marginRight + "px" : spaceMixin(0.5)(props));
  })(props);
};